module.exports = __webpack_public_path__ + "img/83.bc910fe.svg";